import Ajax from '../core/Ajax';

export default class Categories {

	constructor(el) {
		this.el = el;

		this.list = this.el.querySelector('.posts-grid');
		this.type = this.el.dataset.type;
		this.types = this.el.dataset.types ? this.el.dataset.types : null;
		this.method = this.el.dataset.method;
		this.template = this.el.dataset.template;
		this.categories = this.el.dataset.categories;
		this.keyword = this.el.dataset.keyword;
		this.filterCategory = this.el.dataset.filterCategory === 'true';
		this.filterTag = this.el.dataset.filterTag === 'true';
		this.onClickMore = this.onClickMore.bind(this);

		this.initMoreButton();
	}

	initMoreButton() {
		this.moreButton = this.el.querySelector('.categories-load-more-button');
		if (this.moreButton) {
			this.moreButton.addEventListener('click', this.onClickMore);
		}
	}

	parsePayload(response) {
		const parser = new DOMParser();
		const postsHTML = parser.parseFromString(response.posts, 'text/html');
		const moreButtonHTML = parser.parseFromString(response.moreButton, 'text/html');
		const posts = postsHTML.querySelectorAll('.grid-item');
		const moreButton = moreButtonHTML.querySelector('.categories-load-more-button');

		for (let post of posts) {
			this.list.appendChild(post);
		}

		if (moreButton) {
			this.moreButton.dataset.offset = moreButton.dataset.offset;
			this.moreButton.classList.remove('pointer-events-none', 'opacity-75');
		} else {
			this.moreButton.parentNode.parentNode.removeChild(this.moreButton.parentNode);
		}
	}

	onClickMore(e) {
		this.moreButton.classList.add('pointer-events-none', 'opacity-75');

		new Ajax({
			method: 'GET',
			params: {
				action: 'ajax_load_posts',
				type: this.type,
				types: this.types,
				method: this.method,
				template: this.template,
				categories: this.categories,
				keyword: this.keyword,
				number: this.moreButton.dataset.number,
				offset: this.moreButton.dataset.offset,
				buttonLabel: this.moreButton.textContent,
				filterCategory: this.filterCategory,
				filterTag: this.filterTag,
			},
			callback: ajax => {
				if (ajax.ok && !ajax.response.error) {
					this.parsePayload(ajax.response);
				} else {
					console.error(ajax.response.error);
				}
			}
		});
	}
}
